import { render } from "./fitterRowPlaceholder.vue?vue&type=template&id=0d69d65a"
const script = {}

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__